import { collection, doc, limit, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '../firebase';

export function subscribeAmlAlerts(sube, onData, onError) {
  if (!sube) return () => {};
  const q = query(
    collection(db, 'subeler', sube, 'amlAlerts'),
    orderBy('createdAt', 'desc'),
    limit(150)
  );
  return onSnapshot(
    q,
    (snap) => onData(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
    (err) => onError?.(err)
  );
}

export function subscribeAmlSources(onData, onError) {
  return onSnapshot(
    collection(db, 'amlSources'),
    (snap) => onData(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
    (err) => onError?.(err)
  );
}

export function subscribeAmlSettings(onData, onError) {
  return onSnapshot(
    doc(db, 'amlSettings', 'global'),
    (snap) => onData(snap.exists() ? snap.data() : null),
    (err) => onError?.(err)
  );
}
